// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__21xJ8","detailsBorder":"styles_detailsBorder__2_-Q_"};